const { default: API } = require("../api/API");

function getDiscount({ business_id, discount_code, body = {} }) {
  return new Promise((resolve, reject) => {
    API.post(
      `discount/${business_id}/discount-code/${discount_code}`,
      body
    ).then(resolve, reject);
  });
}

export default getDiscount;
